import { useEffect, useRef } from "react";
import { AddQuoteProductCatalogDrawerFormValues } from "@/Contracts/ProposalBuilder/Block";
import { convertQuoteProductPricesToQuoteCurrency } from "./convertQuoteProductCurrency";

export const useAutoSubmitQuoteProducts = (
	selectedQuoteProducts: AddQuoteProductCatalogDrawerFormValues[],
	unfilledSelectedQuoteProductIds: string[],
	companyToQuoteRate: number,
	onSubmit: (products: AddQuoteProductCatalogDrawerFormValues[]) => void
): void => {
	const companyToQuoteRateRef = useRef(companyToQuoteRate);
	companyToQuoteRateRef.current = companyToQuoteRate;

	useEffect(() => {
		if (
			!unfilledSelectedQuoteProductIds.length &&
			selectedQuoteProducts.length
		) {
			onSubmit(
				selectedQuoteProducts.map(product =>
					convertQuoteProductPricesToQuoteCurrency(
						product,
						companyToQuoteRateRef.current
					)
				)
			);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [selectedQuoteProducts, unfilledSelectedQuoteProductIds]);
};
